module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M7 3c2.2 0 4 1.8 4 4s-1.8 4-4 4c-1.3 0-2.5-.7-3.3-1.7L7 7V3\"/></g></svg>\n"


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_status_running.svg
// module id = ../../views/shared/icons/_icon_status_running.svg
// module chunks = commit_pipelines job_details pipelines pipelines_details vue_merge_request_widget